import React from 'react';
import { PapiDeviation, RelatedBlock } from '@wix/da-papi-types';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import TierSidebarCard from '../../../../DeviationViews/TierSidebarCard';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { getTierListCardBI } from '../../../helpers';
import SubscriptionLockFTUE from '../../../../Tier/ftue/SubscriptionLockFTUE';
import { useSubscriptionLockSidebarFTUE } from '../../../../Tier/ftue/useSubscriptionLockFTUE';
import s from './TierList.scss';

interface Props {
  block: RelatedBlock;
  deviation: PapiDeviation;
}

const TierList: React.FC<React.PropsWithChildren<Props>> = ({
  block,
  deviation: parentDeviation,
}) => {
  const { isShowingSubscriptionsFTUE, dropFlag } = useSubscriptionLockSidebarFTUE(
    block.contentType,
    parentDeviation
  );

  return (
    <SidebarBlockWrapper
      deviation={parentDeviation}
      block={block}
      className={s[block.contentType]}
      headerClassName={s['header']}
      titleClassName={s['title']}
      seeAllClassName={s['link']}
    >
      <DeviationDuperbrowseContext
        streamId={`sidebar-tiers-${block.contentType}`}
        deviations={block.deviations ?? []}
        parent={{
          typeId: getDeviationResourceType(parentDeviation),
          itemId: parentDeviation.deviationId,
        }}
      >
        {block.deviations?.map((tier, i) =>
          isShowingSubscriptionsFTUE && i === 0 ? (
            <SubscriptionLockFTUE
              dropFlag={dropFlag}
              className={s['ftue']}
              key={tier.deviationId}
              deviation={tier}
            />
          ) : (
            <TierSidebarCard
              key={tier.deviationId}
              biData={getTierListCardBI(block.contentType, tier)}
              className={s['tier']}
              deviation={tier}
            />
          )
        )}
      </DeviationDuperbrowseContext>
    </SidebarBlockWrapper>
  );
};
TierList.displayName = 'TierList';

export default TierList;
